import styled from "styled-components";

export const Container = styled.div`
  width: 85%;
  display: flex;
  flex-direction: column;
  margin-top: 8.6vh;
  align-items: center;
`;

export const Title = styled.span`
  max-width: 60%;
  text-align: center;
  font-size: 7.142857142857142vh;
  color: #011f59;
  text-align: center;
`;

export const SubTitle = styled.span`
  margin-top: 9.5vh;
  text-align: center;
  font-size: 5.714285714285714vh;
  color: #929292;
  line-height: 19.26px;
  width: 75%;
`;
